<div class="content-wrapper">
  <div class="w-100">
    <h1 class="head1">Add User</h1>
  </div>
  <div class="row">
    <div class="col-md-6 mb-3">
      <div class="card shadow-sm p-3">
        <h5 class="font-15p mb-3">Account Details</h5>
        <form [formGroup]="userForm" (ngSubmit)="onSubmit()">
          <div class="mb-2 row">
            <label class="col-form-label col-md-3"
              >User Name<span class="text-danger">*</span></label
            >
            <div class="col-md-9">
              <input
                formControlName="username"
                type="text"
                class="form-control"
                placeholder="Enter username"
              />
              <div
                *ngIf="
                  getControl('username')?.invalid &&
                  getControl('username')?.touched
                "
                class="text-danger text-center m-0"
              >
                <ng-container
                  *ngIf="getControl('username')?.errors?.['required']"
                >
                  User Name is required.
                </ng-container>
                <ng-container
                  *ngIf="getControl('username')?.errors?.['whitespace'] && !getControl('username')?.errors?.['required']"
                >
                  User Name can't be empty.
                </ng-container>
              </div>
            </div>
          </div>
          <div class="mb-2 row">
            <label class="col-form-label col-md-3"
              >Email ID<span class="text-danger">*</span></label
            >
            <div class="col-md-9">
              <input
                formControlName="email"
                type="email"
                class="form-control"
                placeholder="Enter email ID"
              />
              <p
                *ngIf="getControl('email')?.touched"
                class="text-danger text-center m-0"
              >
                <ng-container *ngIf="getControl('email')?.errors?.['required']">
                  Email is required
                </ng-container>
                <ng-container
                  *ngIf="getControl('email')?.errors?.['invalidEmail'] && !getControl('email')?.errors?.['required']"
                >
                  Invalid email format
                </ng-container>
              </p>
            </div>
          </div>
          <div class="mb-2 row">
            <label class="col-form-label col-md-3"
              >Profile Image<span class="text-danger">*</span></label
            >
            <div class="col-md-9">
              <div class="d-flex">
                <input
                  type="text"
                  class="form-control me-2"
                  placeholder="No file chosen"
                  [value]="profileImangeName || 'No file chosen'"
                  readonly
                />
                <div class="custom-input-file">
                  <label
                    for="fileInput"
                    class="file-input-label btn btn-primary-sa"
                    >Browse</label
                  >
                  <input
                    type="file"
                    class="file-input"
                    id="fileInput"
                    (change)="onFileChange($event)"
                  />
                </div>
              </div>

              <p
                *ngIf="getControl('profileImage')?.touched"
                class="text-danger text-center m-0"
              >
                <ng-container
                  *ngIf="getControl('profileImage')?.hasError('required')"
                >
                  Profile Image is required.
                </ng-container>
              </p>

              <p *ngIf="fileError" class="text-danger text-center m-0">
                {{ fileError }}
              </p>
            </div>
          </div>
          <h5 class="font-15p my-4">Personal Details</h5>
          <div class="mb-2 row">
            <label class="col-form-label col-md-3"
              >First Name<span class="text-danger">*</span></label
            >
            <div class="col-md-9">
              <input
                formControlName="firstName"
                type="text"
                class="form-control"
                placeholder="Enter first name"
              />
              <div
                *ngIf="
                  getControl('firstName')?.invalid &&
                  getControl('firstName')?.touched
                "
                class="text-danger text-center m-0"
              >
                <ng-container
                  *ngIf="getControl('firstName')?.errors?.['required']"
                >
                  First Name is required.
                </ng-container>
                <ng-container
                  *ngIf="getControl('firstName')?.errors?.['whitespace'] && !getControl('firstName')?.errors?.['required']"
                >
                  First Name can't be empty.
                </ng-container>
              </div>
            </div>
          </div>
          <div class="mb-2 row">
            <label class="col-form-label col-md-3"
              >Last Name<span class="text-danger">*</span></label
            >
            <div class="col-md-9">
              <input
                formControlName="lastName"
                type="text"
                class="form-control"
                placeholder="Enter last name"
              />
              <div
                *ngIf="
                  getControl('lastName')?.invalid &&
                  getControl('lastName')?.touched
                "
                class="text-danger text-center m-0"
              >
                <ng-container
                  *ngIf="getControl('lastName')?.errors?.['required']"
                >
                  Last Name is required.
                </ng-container>
                <ng-container
                  *ngIf="getControl('lastName')?.errors?.['whitespace'] && !getControl('lastName')?.errors?.['required']"
                >
                  Last Name can't be empty.
                </ng-container>
              </div>
            </div>
          </div>
          <div class="mb-2 row">
            <label class="col-form-label col-md-3"
              >Date of Birth<span class="text-danger">*</span></label
            >
            <div class="col-md-9">
              <input
                type="text"
                class="form-control"
                placeholder="Select a date"
                bsDatepicker
                [bsConfig]="datePickerConfig"
                formControlName="dob"
                required
                [readonly]="isDateSelected"
                (bsValueChange)="onDateSelected()"
              />
              <div
                *ngIf="
                  userForm.get('dob')!.invalid &&
                  (userForm.get('dob')!.touched || userForm.get('dob')!.dirty)
                "
                class="text-danger text-center m-0"
              >
                Date of birth is required.
              </div>
            </div>
          </div>
          <div class="mb-2 row">
            <label class="col-form-label col-md-3"
              >Gender<span class="text-danger">*</span></label
            >
            <div class="col-md-9">
              <select formControlName="gender" class="form-select">
                <option value="">Select gender</option>
                <option value="female">Female</option>
                <option value="male">Male</option>
                <option value="others">Others</option>
              </select>
              <div
                *ngIf="
                  userForm.get('gender')!.invalid &&
                  (userForm.get('gender')!.touched ||
                    userForm.get('gender')!.dirty)
                "
                class="text-danger text-center m-0"
              >
                Gender is required.
              </div>
            </div>
          </div>
          <!-- <div class="mb-2 row">
            <label class="col-form-label col-md-3">Phone Number</label>
            <div class="col-md-9">
              <input
                formControlName="phoneNumber"
                type="text"
                class="form-control"
                placeholder="Enter phone number"
              />
              <div
                *ngIf="userForm.get('phoneNumber')?.touched"
                class="text-danger text-center m-0"
              >
                <p *ngIf="userForm.get('phoneNumber')?.errors?.['required']">
                  Phone Number is required.
                </p>

                <p
                  *ngIf="!userForm.get('phoneNumber')?.errors?.['required'] && userForm.get('phoneNumber')?.errors?.['invalidNumber']"
                >
                  Phone number is not valid.
                </p>
              </div>
            </div>
          </div> -->
          <div class="mb-2 row">
            <label class="col-form-label col-md-3"
              >Phone Number<span class="text-danger">*</span></label
            >
            <div class="col-md-3">
              <select class="form-control" formControlName="countryCode">
                <option
                  *ngFor="let country of countryCodes"
                  [value]="country.dial_code"
                >
                  {{ country.name }} ({{ country.dial_code }})
                </option>
              </select>
              <p
                *ngIf="
                  getControl('countryCode')?.invalid &&
                  getControl('countryCode')?.touched
                "
                class="text-danger m-0"
              >
                Please select country Code.
              </p>
            </div>

            <div class="col-md-6">
              <input
                type="text"
                class="form-control"
                formControlName="ConsumerPhone"
                placeholder="Enter phone number"
              />
              <p
                *ngIf="
                  getControl('ConsumerPhone')?.invalid &&
                  getControl('ConsumerPhone')?.touched
                "
                class="text-danger m-0"
              >
                Phone number is required and should 10 digits.
              </p>
            </div>
          </div>
          <div class="mb-4 row">
            <label class="col-form-label col-md-3"
              >Contact Info<span class="text-danger">*</span></label
            >
            <div class="col-md-9">
              <textarea
                formControlName="contactInfo"
                class="form-control"
                placeholder="Enter contact info"
              ></textarea>
              <div
                *ngIf="
                  userForm.get('contactInfo')!.invalid &&
                  (userForm.get('contactInfo')!.touched ||
                    userForm.get('contactInfo')!.dirty)
                "
                class="text-danger text-center m-0"
              >
                Contact Info is required.
              </div>
            </div>
          </div>
          <div class="mb-2 row">
            <label class="col-form-label col-md-3">&nbsp;</label>
            <div class="col-md-9 text-end">
              <button
                type="button"
                class="btn btn-secondary-sa ms-2 mb-2"
                (click)="oncancel()"
              >
                Cancel
              </button>
              <button type="submit" class="btn btn-primary-sa ms-2 mb-2">
                Submit
              </button>
            </div>
          </div>
        </form>
      </div>
    </div>
  </div>
</div>
